export enum Gender {
  Male = 'male',
  Female = 'female',
  Other = 'other',
}

export const GENDERS: readonly Gender[] = Object.values(Gender)
